
const initialState = {
    marital: [],
};

const maritalReducer = (state = initialState, action) => {
    switch (action.type) {
        case "ADD_MARITAL_NAME":
            return state = { ...state, marital: [action.payload, ...state.marital ] }
        case "UPDATE_MARITAL_NAME":
            return state = { ...state, marital: state?.marital?.map((marital) => marital._id === action.payload._id ? action?.payload : marital)}   
        case "UPDATE_MARITAL_STATUS":
            return state = { ...state, marital: state?.marital?.map((marital) => marital._id === action.payload._id ? action?.payload : marital)}
            case "GET_ALL_MARITAL":
                return { ...state, marital: action.payload };
        default:
            return state;
    }
}

export default maritalReducer;